export const MERCHANT_ENTRY_PATH = "/we-pedidos/comercios";
export const MERCHANT_HOME_PATH = "/app/comercios";

export const isDeliveryOnly = (source = {}) => {
  // Missing legacy mode is allowed only with explicit channel flags. Unknown
  // modes (including a conflicting kiosk alias) must not become delivery.
  const modes = [source?.serviceMode, source?.service_mode];
  return modes.every((mode) => mode == null || mode === "salon") &&
    (source?.salonEnabled ?? source?.salon_enabled) === false &&
    (source?.deliveryEnabled ?? source?.delivery_enabled) === true;
};

export const buildMerchantModeDefaults = (mode = "delivery") => {
  const restaurant = mode === "restaurant";
  const kiosk = mode === "kiosk";

  return {
    serviceMode: kiosk ? "kiosk" : "salon",
    salonEnabled: restaurant,
    deliveryEnabled: !kiosk,
    wePedidosEnabled: false,
    waiterEnabled: restaurant,
    stockEnabled: restaurant || kiosk,
    aiEnabled: true,
  };
};
